import { useAuth0 } from "@auth0/auth0-react";
import logo from "assets/images/logo.png";
import BlackContainer from "components/Common/BlackContainer";
import environment from "environment/environment";
import React, { useEffect, useMemo } from "react";
import useNotificationStore from "store/Notification/state";
import HeaderComponent from "xpi-black-ui/Common/Header";
import { Container, ContainerBorder } from "./styles";

const Header = ({ userName }) => {
	const { logout } = useAuth0();
	const { setOpen } = useNotificationStore();

	const navigationItems = useMemo(
		() => [
			{ link: "/operacoes", title: "Operações Disponíveis" },
			{ link: "/antecipacao", title: "Antecipação" },
			{ link: "/central-de-propostas", title: "Central de Propostas" },
			{ link: "/relatorios", title: "Relatórios Gerenciais" },
		],
		[],
	);

	useEffect(() => {
		const addLogoutHandler = () => {
			const sairElement = Array.from(document.querySelectorAll("span")).find(
				(el) => el.textContent && el.textContent.trim() === "Sair",
			);

			if (sairElement && !sairElement.hasAttribute("data-logout-handler")) {
				sairElement.setAttribute("data-logout-handler", "true");
				sairElement.style.cursor = "pointer";

				sairElement.addEventListener("click", (e) => {
					e.preventDefault();
					e.stopPropagation();

					logout({
						logoutParams: {
							returnTo: `${window.location.origin}${environment.DOMAIN_PATH}`,
						},
					});
				});
			}
		};

		setTimeout(addLogoutHandler, 500);

		const observer = new MutationObserver(addLogoutHandler);
		observer.observe(document.body, { childList: true, subtree: true });

		return () => observer.disconnect();
	}, [logout]);

	return (
		<ContainerBorder>
			<BlackContainer>
				<Container>
					<HeaderComponent
						userName={userName || ""}
						navigationItems={navigationItems}
						logo={<img src={logo} alt="logo" style={{ width: "85px" }} />}
						onClickNotification={() => setOpen(true)}
					/>
				</Container>
			</BlackContainer>
		</ContainerBorder>
	);
};

export default Header;
